import { FaLaptopCode, FaPhp, FaGraduationCap, FaEnvelope } from "react-icons/fa";
import { SiNextdotjs } from "react-icons/si";
const Home = () => {
    return (
        <div className="space-y-4">
            <p className="text-2xl font-bold underline underline-offset-4">
                Welcome!
            </p>
            <p className="text-lg">
                I'm a QA Support & DevOps Engineer who has a love for computers. I'm currently learning Playwright to improve my QA automation skills, and putting my 110% effort into it.
            </p>
            <p className="text-lg">
                I’m continuing my education with a <span className="font-bold"> Bachelor of Technology in Software Engineering Technology</span>. 
            </p>
            <p className="text-lg">
                Beyond programming, I enjoy playing <span className="font-semibold">basketball</span>, reading (mostly <span className="font-semibold">manga</span>), exploring <span className="font-semibold">films</span>, and <span className="font-semibold">gaming</span>. These hobbies inspire creativity and help me maintain a balanced lifestyle.
            </p>
            <p className="text-lg">
                Feel free to connect with me at <span className="font-bold"> redam2001@outlook.com</span>. I’m always open to collaboration opportunities, exciting projects, or simply exchanging ideas!
            </p>
        </div>
    );
};

export default Home;
